/**
 * Hall Booking Module Entry Point
 * Orchestrates hall booking calendar and form functionality
 */

import {
    initHallBookingCalendar,
    refreshHallBookingCalendar,
    getHallBookingCalendar
} from './_calendar.js';

import {
    initHallBookingForm,
    getCurrentStep,
    goToStep
} from './_booking.js';

import { initDeliveryLocation } from './_delivery.js';
import { initSetupHoursBanner } from './_setupHours.js';

export default class HallBookingModule {
    constructor() {
        this.calendar = null;
        this.form = null;

        this.init();
    }

    /**
     * Initialize hall booking module components
     */
    init() {

        // `#fullCalendarGemengApp`, et non plus `.calendar-booking` : cette classe
        // n'existe dans AUCUN gabarit (vérifié sur l'ensemble de /layout et
        // /elements). La branche calendrier de ce module ne s'exécutait donc jamais,
        // et le calendrier de la fiche salle ne devait son fonctionnement qu'à
        // l'auto-initialisation de `_calendar.js` (son `DOMContentLoaded` de fin de
        // fichier). `initHallBookingCalendar()` est idempotente, les deux chemins
        // peuvent coexister sans double rendu.
        const calendarEl = document.getElementById('fullCalendarGemengApp');
        if (calendarEl) {
            initHallBookingCalendar();
            this.calendar = getHallBookingCalendar();
        }

        // Initialize form if present
        const formEl = document.querySelector('.form-bookingapp .multi-step-form');
        if (formEl) {
            initHallBookingForm();
            initDeliveryLocation();
            initSetupHoursBanner();

            // Sur mobile, la barre « Précédent / Suivant » est fixée en bas de l'écran.
            // Cette classe permet au pied de page de lui réserver sa hauteur, sans quoi
            // ses derniers liens finissent dessous — et uniquement sur les pages
            // concernées, puisqu'elle n'est posée qu'ici.
            document.body.classList.add('has-booking-nav');
            this.form = { getCurrentStep, goToStep };
        }
    }

    /**
     * Get calendar instance for external access
     */
    getCalendar() {
        return this.calendar;
    }

    /**
     * Get form instance for external access
     */
    getForm() {
        return this.form;
    }

    /**
     * Check if module is available on current page
     */
    static isAvailable() {
        return document.getElementById('fullCalendarGemengApp') ||
               document.querySelector('.form-bookingapp .multi-step-form');
    }

    /**
     * Factory method to create instance only if needed
     */
    static createIfNeeded() {
        if (HallBookingModule.isAvailable()) {
            return new HallBookingModule();
        }
        return null;
    }
}

// Re-export key functions for backward compatibility
export {
    initHallBookingCalendar,
    refreshHallBookingCalendar,
    getHallBookingCalendar,
    initHallBookingForm,
    getCurrentStep,
    goToStep
};
